var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArchivedinline = function SvgArchivedinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M11.5 5.75 9 8.25l-2.5-2.5M9 8.25v-5.5M16.212 9.75h-4.464v1a1 1 0 0 1-1 1h-3.5a1 1 0 0 1-1-1v-1H1.785"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M12 2.75h.137a2 2 0 0 1 1.862 1.269l2.113 5.379c.092.233.138.481.138.731v3.121a2 2 0 0 1-2 2H3.75a2 2 0 0 1-2-2v-3.121c0-.25.047-.498.138-.731l2.113-5.379A2 2 0 0 1 5.863 2.75H6"
  })));
};
export default SvgArchivedinline;